import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/4jNChWMubsUVoT4hzpEWU9/Asset_12x.png';
export function Footer() {
  return <footer className="relative bg-robeta-black text-white pt-20 pb-8 overflow-hidden" data-id="element-102">
      {/* Subtle atmospheric glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-robeta-copper/5 via-transparent to-transparent pointer-events-none" data-id="element-103" />

      {/* Decorative copper line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-robeta-copper/40 to-transparent" data-id="element-104" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-105">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20" data-id="element-106">
          {/* Brand Col */}
          <div className="space-y-6" data-id="element-107">
            <Link to="/" className="block" data-id="element-108">
              <img src={LOGO_URL} alt="Robeta" className="h-8 w-auto brightness-0 invert" data-id="element-109" />
            </Link>
            <p className="text-white/50 font-light text-sm leading-relaxed max-w-xs" data-id="element-110">
              European luxury camper vans, precision engineered for the Canadian
              landscape. Discover a new standard of travel.
            </p>
          </div>

          {/* Explore Col */}
          <div data-id="element-111">
            <h4 className="text-xs font-bold text-robeta-copper uppercase tracking-wide-editorial mb-6" data-id="element-112">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-113">
              <li data-id="element-114">
                <Link to="/models" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-115">
                  Models
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/dealer-network" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-117">
                  Dealer Network
                </Link>
              </li>
              <li data-id="element-118">
                <Link to="/robeta-difference" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-119">
                  The Robeta Difference
                </Link>
              </li>
              <li data-id="element-120">
                <Link to="/tools" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-121">
                  Brochures
                </Link>
              </li>
            </ul>
          </div>

          {/* Discover Col */}
          <div data-id="element-122">
            <h4 className="text-xs font-bold text-robeta-copper uppercase tracking-wide-editorial mb-6" data-id="element-123">
              Discover
            </h4>
            <ul className="space-y-4" data-id="element-124">
              <li data-id="element-125">
                <Link to="/about-robeta" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-126">
                  About Us
                </Link>
              </li>
              <li data-id="element-127">
                <Link to="/moments-on-the-map" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-128">
                  Moments on the Map
                </Link>
              </li>
              <li data-id="element-129">
                <Link to="/tools" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-130">
                  Tools & Configurator
                </Link>
              </li>
              <li data-id="element-131">
                <Link to="/contact" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-132">
                  Contact
                </Link>
              </li>
              <li data-id="element-133">
                <Link to="/blog" className="text-white/60 hover:text-robeta-copper transition-colors text-sm uppercase tracking-wide" data-id="element-134">
                  Journal
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect Col - Social Icons Only */}
          <div data-id="element-135">
            <h4 className="text-xs font-bold text-robeta-copper uppercase tracking-wide-editorial mb-6" data-id="element-136">
              Connect
            </h4>
            <div className="flex gap-4" data-id="element-137">
              <a href="#" className="group w-12 h-12 rounded-full border border-white/10 bg-white/5 flex items-center justify-center hover:border-robeta-copper hover:bg-robeta-copper/10 transition-all duration-300" aria-label="Instagram" data-id="element-138">
                <Instagram className="w-5 h-5 text-white/70 group-hover:text-robeta-copper transition-colors" data-id="element-139" />
              </a>
              <a href="#" className="group w-12 h-12 rounded-full border border-white/10 bg-white/5 flex items-center justify-center hover:border-robeta-copper hover:bg-robeta-copper/10 transition-all duration-300" aria-label="Facebook" data-id="element-140">
                <Facebook className="w-5 h-5 text-white/70 group-hover:text-robeta-copper transition-colors" data-id="element-141" />
              </a>
              <a href="#" className="group w-12 h-12 rounded-full border border-white/10 bg-white/5 flex items-center justify-center hover:border-robeta-copper hover:bg-robeta-copper/10 transition-all duration-300" aria-label="YouTube" data-id="element-142">
                <Youtube className="w-5 h-5 text-white/70 group-hover:text-robeta-copper transition-colors" data-id="element-143" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-144">
          <div className="text-white/40 text-xs uppercase tracking-wider" data-id="element-145">
            © 2026 Robeta Canada. All rights reserved.
          </div>

          <div className="flex space-x-8" data-id="element-146">
            <a href="#" className="text-white/40 hover:text-white text-xs uppercase tracking-wider transition-colors" data-id="element-147">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white text-xs uppercase tracking-wider transition-colors" data-id="element-148">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}